export default __webpack_public_path__ + "static/media/misc-books2-768w.47f534a6.png";